export interface Experience {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  image: string;
  /** Descriptive, SEO-friendly alt text for the image. */
  alt: string;
  duration: string;
}

// All photos are real, freely-licensed images illustrating each actual
// experience/region, sourced from Wikimedia Commons (CC BY-SA).
export const experiences: Experience[] = [
  {
    id: 1,
    title: 'Albanian Riviera',
    subtitle: 'Europe\'s Hidden Coastline',
    description: 'Discover secret beaches, dramatic cliffs, and crystal-clear Ionian waters along one of the Mediterranean\'s last unspoiled coastlines. From Vlorë to Sarandë, every cove tells a story.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Albanian_Riviera_form_Llogara_panorama.JPG?width=1600',
    alt: 'Panoramic view of the Albanian Riviera from the Llogara Pass — dramatic cliffs, Ionian Sea and Mediterranean coastline between Vlorë and Sarandë',
    duration: '5-10 days',
  },
  {
    id: 2,
    title: 'Ottoman Heritage',
    subtitle: 'Journey Through Time',
    description: 'Walk the cobblestone streets of Berat and Gjirokastër, UNESCO World Heritage cities where Ottoman architecture tells centuries of Albanian history. Expert local guides reveal hidden stories.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Kalaja,_Berat.JPG?width=1200',
    alt: 'Berat Castle (Kalaja) overlooking the UNESCO World Heritage Ottoman city of Berat, Albania — cultural heritage travel',
    duration: '3-7 days',
  },
  {
    id: 3,
    title: 'Albanian Alps Trek',
    subtitle: 'The Accursed Mountains',
    description: 'Traverse the legendary Theth-to-Valbona trail through the Accursed Mountains. Dramatic peaks, alpine meadows, and the warmth of traditional mountain guesthouses await.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Valbona_Valley_National_Park,_North_Albania.jpg?width=1200',
    alt: 'Valbona Valley National Park in the northern Albanian Alps — legendary Theth to Valbona trek through the Accursed Mountains',
    duration: '4-8 days',
  },
  {
    id: 4,
    title: 'Culinary Albania',
    subtitle: 'Taste the Tradition',
    description: 'From farm-to-table feasts in the countryside to seafood on the Riviera, explore Albania\'s rich culinary heritage. Learn to make byrek, tavë kosi, and discover world-class wines.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Tiran%C3%AB,_Albania,_31_December_2022_-_cheese_byrek.jpg?width=1200',
    alt: 'Traditional Albanian cheese byrek pastry in Tirana — culinary travel and farm-to-table Mediterranean food experience in Albania',
    duration: '3-7 days',
  },
  {
    id: 5,
    title: 'Archaeological Odyssey',
    subtitle: 'Civilizations Unveiled',
    description: 'Explore 2,500 years of history at Butrint, Apollonia, and Durrës. From Greek theaters to Roman mosaics and Byzantine churches, Albania is an open-air museum waiting to be discovered.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Butrint_Albania_10_baptistery.jpg/1280px-Butrint_Albania_10_baptistery.jpg',
    alt: 'Ancient Byzantine baptistery mosaic at Butrint Archaeological Park, Albania — UNESCO World Heritage Greek, Roman and Byzantine ruins',
    duration: '4-10 days',
  },
  {
    id: 6,
    title: 'Boutique Retreats',
    subtitle: 'Luxury Reimagined',
    description: 'Stay in converted Ottoman mansions, clifftop boutique hotels, and alpine lodges that blend Albanian heritage with contemporary luxury. Intimate, authentic, unforgettable.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Berat,_Mangalem_quarter,_Albania.JPG?width=1200',
    alt: 'Ottoman-era white stone houses of the Mangalem quarter, Berat, Albania — boutique luxury heritage retreats in UNESCO-listed cities',
    duration: '3-14 nights',
  },
];
